import * as d3 from 'd3'
import Signal from '@/pure/Signal'

export default class Graph
{
    constructor(el)
    {
        this.el = el

        this.onOver = new Signal()
        this.onOut = new Signal()
        this.onClick = new Signal()
    }

    resize(width, height)
    {
        this.width = width
        this.height = height

        return this
    }

    reset()
    {
        if (this.svg)
        {
            while (this.el.children.length > 0)
            {
                this.el.removeChild(this.el.children[0])
            }
        }

        const xScale = d3.scaleLinear()
            .range([0, this.width])
            .domain(this.domain.map(pos => pos.x))

        const yScale = d3.scaleLinear()
            .range([this.height, 0])
            .domain(this.domain.map(pos => pos.y))

        const plotLine = d3.line()
            .x(d => xScale(d.x))
            .y(d => yScale(d.y))

        this.svg = d3.select(this.el)
            .append('svg')
            .attr('width', this.width + this.margin.left + this.margin.right)
            .attr('height', this.height + this.margin.top + this.margin.bottom)
            .attr('class', 'svg')
            .attr('style', 'transform: translateX('
                + -this.margin.left + 'px) translateY('
                + -this.margin.top + 'px)')

        this.svg.append('g')
            .append('path')
            .attr('transform', 'translate(' + this.margin.left + ',' + this.margin.top + ')')
            .datum(this.mainPoints)
            .attr('d', plotLine)
            .style('fill', 'none')
            .style('stroke', '#f24a54')
            .attr('stroke-width', '2px')

        this.svg.append('g')
            .append('path')
            .attr('transform', 'translate(' + this.margin.left + ',' + this.margin.top + ')')
            .datum(this.secondPoints)
            .attr('d', plotLine)
            .style('fill', 'none')
            .style('stroke', '#bdbdbd')
            .attr('stroke-width', '2px')

        this.svg.append('g')
            .attr('id', 'scatter')
            .attr('transform', 'translate(' + this.margin.left + ',' + this.margin.top + ')')
            .selectAll('.dot')
            .data(this.mainPoints)
            .enter()
            .append('circle')
            .attr('class', 'dot is-enabled')
            .attr('r', 6)
            .attr('cx', d => xScale(d.x))
            .attr('cy', d => yScale(d.y))
            .attr('stroke', '#000')
            .attr('stroke-width', '2px')
            .attr('fill', '#FFF')
            .attr('style', 'cursor: pointer')
            .on('mouseover', data => this.onOver.dispatch(data))
            .on('mouseout', data => this.onOut.dispatch(data))
            .on('click', data => this.onClick.dispatch(data))

        this.svg.append('g')
            .attr('id', 'scatter')
            .attr('transform', 'translate(' + this.margin.left + ',' + this.margin.top + ')')
            .selectAll('.dot')
            .data(this.secondPoints.filter((data, index) => index > 0 && index < this.secondPoints.length - 1))
            .enter().append('circle')
            .attr('class', 'dot')
            .attr('r', 6)
            .attr('cx', d => xScale(d.x))
            .attr('cy', d => yScale(d.y))
            .attr('stroke', '#bdbdbd')
            .attr('stroke-width', '2px')
            .attr('fill', '#FFF')

        return this
    }

    init({
        mainPoints = [],
        secondPoints = [],
        margin = { top: 20, right: 20, bottom: 20, left: 20 },
        domain = []
    } = {})
    {
        this.margin = margin
        this.mainPoints = mainPoints
        this.secondPoints = secondPoints
        this.domain = domain

        return this.reset()
    }
}
